module.exports = __webpack_public_path__ + "img/ru.demidov.d9ef4892.jpg";